var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.859,
    height: 48.862,
    viewBox: "0 0 48.859 48.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4530",
    "data-name": "Group 4530",
    transform: "translate(-3262.289 -1669.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13665",
    "data-name": "Path 13665",
    d: "M69.571,664.566a5.389,5.389,0,0,1,0,7.618L31.486,710.271a5.388,5.388,0,0,1-7.619-7.619l38.087-38.085a5.389,5.389,0,0,1,7.618,0",
    transform: "translate(3240 1007.001)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13666",
    "data-name": "Path 13666",
    d: "M69.571,710.27a5.389,5.389,0,0,1-7.618,0L23.867,672.185a5.388,5.388,0,0,1,7.619-7.619l38.085,38.087a5.389,5.389,0,0,1,0,7.618",
    transform: "translate(3240 1007)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.869f629ae7a9a88139295e131ba480d3.svg";
export { ForwardRef as ReactComponent };